
 export const GRAPHQL_DEV_CLIENT = "https://api.jayamarun.com/graphql"

 // export const API_URL = "https://api.jayamarun.com"
 export const API_URL = "https://api.chennaisrikalikambal.in"
  //  export const API_URL = "http://localhost:8000"
